<div class="title">{{ 'VOLUNTEERING.external_one_last_thing' | translate }}</div>
<div class="question">{{ 'VOLUNTEERING.external_working_hours_question' | translate }}</div>
<div class="radio-wrapper">
  <input (change)="onWorkingHoursChange($event)" [value]="false" checked id="no_working_hours" name="type" type="radio">
  <label for="no_working_hours">{{ 'VOLUNTEERING_TAB.no_feedback' | translate }}</label>
  <input (change)="onWorkingHoursChange($event)" [value]="true" id="yes_working_hours" name="type" type="radio">
  <label for="yes_working_hours">{{ 'VOLUNTEERING_TAB.yes_feedback' | translate }}</label>
</div>
<div class="info">{{ 'VOLUNTEERING.external_working_hours_info' | translate }}</div>

<div class="d-flex justify-content-center">
  <ns-button
    (callback$)="onConfirm()"
    [classes]="'w-100 ns-font-w-800'"
    [text]="'VOLUNTEERING_TAB.confirm_volunteering' | translate"
    [type]="Constants.BUTTON_TYPE_DEFAULT_YELLOW_FILLED_B">
  </ns-button>
</div>
